import { render, staticRenderFns } from "./LvPopupScrollContent.vue?vue&type=template&id=707e97d1"
import script from "./LvPopupScrollContent.vue?vue&type=script&lang=js"
export * from "./LvPopupScrollContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports